import { gql } from "@apollo/client";

export const UPDATE_INSTRUCTOR_ASSIGNATION_TYPE = gql`
  mutation UpdateInstructorAssignationType(
    $scenarioId: ID!
    $originId: ID!
    $input: UpdateAssignationTypeInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      updateAssignationType(input: $input) {
        skippedValidations
        commited
        validations {
          ... on InvalidInput {
            code
            meta
          }
        }
      }
    }
  }
`;
